import {
  dark as darkTheme,
  light as lightTheme,
  shape as shapeTheme,
  spacing as spacingTheme,
  typographyAdg3 as typographyTheme,
} from '@atlaskit/tokens/tokens-raw';

import isProd from '../../utils/is-prod';

import type {
  TransformedTokenMerged,
  TransformedTokenWithAttributes,
} from './types';

const lightDarkTokens = lightTheme.map(lightToken => {
  const darkToken = darkTheme.find(token => token.name === lightToken.name);
  const mergedToken = {
    ...lightToken,
    darkToken: (darkToken as TransformedTokenWithAttributes)!,
  } as TransformedTokenMerged;

  return mergedToken;
});

const typographyGroups = ['typography', 'fontWeight', 'fontFamily']

const typographyThemeFiltered = typographyTheme.filter(token => typographyGroups.includes(token.attributes.group)).filter(token => token.cleanName !== 'font.body.UNSAFE_small')

const mergedTokens: TransformedTokenMerged[] = lightDarkTokens.concat(
  // @ts-expect-error this is annoying and related to the tokens defintions
  ...spacingTheme,
  ...typographyThemeFiltered,
  ...(!isProd() ? shapeTheme : []),
);

export default mergedTokens;
